
import { useState,useEffect } from "react";



function InputUsername(props)
{
    
   
    
    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);

    const validateEmail = (email) => {

        return true; //login moze byc rozny

        return String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };


    const checkAndChange = (e) =>
    {
        var v = e.target.value;
        setVal(v);

        var correct = false;

        if(req == '1' && v.length < 1) correct = false;         
        if(req == '0' && v.length < 1) correct = true;
        

        if(v.length > 0 && validateEmail(v) )
        {
            correct = true;
        }
                        
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    

    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })
    

    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }



    var cnX = cn;
    if( val !=null && val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }

    var defClass = " w250 ";
    if(props.className != undefined ) defClass = props.className;


    return <fieldset>
        <input type="email"  value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={defClass + "  " + cnX} />        
        <br/>
             <span className="form_err">{err + " "} &nbsp; </span>
    </fieldset>
}


export default InputUsername;